import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the view for partners products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (
                                            devConfig.getPermAction(
                                                'partnersProductsEdit', // Permission check for editing
                                                'Edit',
                                            )
                                        ) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                        } else {
                                            return ''; // No icon if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Localized column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Product', // Column ID
                                    header: _('Producto'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProviderId', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FilterCountry', // Column ID
                                    header: _('Filtro País'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Mobile', // Column ID
                                    header: _('Mobile'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'S', value: _('Activado') },
                                        { id: 'N', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Desktop', // Column ID
                                    header: _('Escritorio'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'S', value: _('Activado') },
                                        { id: 'N', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Maximum', // Column ID
                                    header: _('Máximo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Minimum', // Column ID
                                    header: _('Mínimo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProcessingTime', // Column ID
                                    header: _('Tiempo Procesamiento'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Order', // Column ID
                                    header: _('Orden'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FeaturedOrder', // Column ID
                                    header: _('Orden Destacado'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Rows', // Column ID
                                    header: _('Filas'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Columns', // Column ID
                                    header: _('Columnas'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'New', // Column ID
                                    header: _('¿Es nuevo?'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'S', value: _('Si') },
                                        { id: 'N', value: _('No') },
                                    ],
                                    width: 90, // Column width
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit button click event
                                    $$('editwinPartnerProducts').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'PartnersProducts/GetPartnersProducts'; // API URL for fetching partners products
        var products = []; // Array to hold products data
        var filter = ''; // Filter string for API requests
        var optionsCategorias = []; // Array to hold category options
        var vthis = this; // Reference to the current instance
        var popup = ''; // Variable for the edit popup
        var popupAdd = ''; // Variable for the add popup
        var arrayPartnersAdd = []; // Array for partners to add
        var arrayPartnersWithoutAdd = []; // Array for partners without add
        var arrayPartnersEdit = []; // Array for partners to edit
        var arrayPartnersWithoutEdit = []; // Array for partners without edit
        var arrayAdd = []; // Array for add operations
        var arrayWithoutAdd = []; // Array for operations without add
        var arrayAddEdit = []; // Array for edit operations
        var arrayWithoutAddEdit = []; // Array for operations without edit

        // AJAX request to fetch categories
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Categories/GetCategories', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        // Loop through response data
                        resp.data[i].id = resp.data[i].Id; // Map Id to id
                        resp.data[i].value = resp.data[i].Description; // Map Description to value
                    }
                    optionsCategorias = resp.data; // Store category options
                    popup = webix.ui({
                        // Create edit popup
                        view: 'window',
                        id: 'editwinPartnerProducts', // ID for the edit window
                        width: screen.width < 500 ? 500 : 650, // Set width based on screen size
                        height: screen.width < 500 ? 650 : 650, // Set height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            // Header configuration
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Editar Productos Partner'), // Localized label
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        // Close button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: false, // Non-modal popup
                        body: {
                            // Body configuration
                            view: 'scrollview', // Scrollable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            body: {
                                view: 'form', // Form view
                                id: 'editform', // ID for the edit form
                                width: screen.width < 500 ? 500 : 650, // Set width based on screen size
                                height: screen.width < 500 ? 600 : 600, // Set height based on screen size
                                elements: [
                                    // Form elements
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Id
                                                labelPosition: 'top',
                                                label: 'Id', // Label for Id
                                                name: 'Id', // Name for the input
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'text', // Text input for Processing Time
                                                labelPosition: 'top',
                                                label: _('Tiempo Procesamiento'), // Localized label
                                                name: 'ProcessingTime', // Name for the input
                                                labelWidth: 160, // Label width
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Product
                                                labelPosition: 'top',
                                                label: _('Productos'), // Localized label
                                                name: 'Product', // Name for the input
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'combo', // Combo input for Provider
                                                labelPosition: 'top',
                                                label: _('Proveedor'), // Localized label
                                                name: 'ProviderId', // Name for the input
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Partner
                                                labelPosition: 'top',
                                                label: _('Partner'), // Localized label
                                                name: 'Partner', // Name for the input
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'combo', // Combo input for IsActivate
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'IsActivate', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for IsVerified
                                                labelPosition: 'top',
                                                label: _('Verificado'), // Localized label
                                                name: 'IsVerified', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo input for FilterCountry
                                                labelPosition: 'top',
                                                label: _('Filtro País'), // Localized label
                                                name: 'FilterCountry', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for Mobile
                                                labelPosition: 'top',
                                                label: _('Mobile'), // Localized label
                                                name: 'Mobile', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'combo', // Combo input for Desktop
                                                labelPosition: 'top',
                                                label: _('Escritorio'), // Localized label
                                                name: 'Desktop', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Maximum
                                                labelPosition: 'top',
                                                label: _('Máximo'), // Localized label
                                                name: 'Maximum', // Name for the input
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Minimum
                                                labelPosition: 'top',
                                                label: _('Mínimo'), // Localized label
                                                name: 'Minimum', // Name for the input
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Order
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for FeaturedOrder
                                                labelPosition: 'top',
                                                label: _('Orden Destacado'), // Localized label
                                                name: 'FeaturedOrder', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Rows
                                                labelPosition: 'top',
                                                label: _('Filas'), // Localized label
                                                name: 'Rows', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Columns
                                                labelPosition: 'top',
                                                label: _('Columnas'), // Localized label
                                                name: 'Columns', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Note
                                                labelPosition: 'top',
                                                label: _('Explicación'), // Localized label
                                                name: 'Note', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'text' }, // Input type
                                            },
                                            {
                                                view: 'combo', // Combo input for New
                                                labelPosition: 'top',
                                                label: _('¿Es nuevo?'), // Localized label
                                                name: 'New', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    { id: 'S', value: _('Si') }, // Localized value
                                                    { id: 'N', value: _('No') }, // Localized value
                                                ],
                                                readonly: false, // Editable input
                                            },
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Localized button text
                                                click: function () {
                                                    // Click event for cancel button
                                                    this.getTopParentView().hide(); // Hide the popup
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Localized button text
                                                click: function ($e) {
                                                    // Click event for save button
                                                    var values = $$('editform').getValues(); // Get form values
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for the request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnerProduct/UpdatePartnerProductDetails', // API URL for updating product details
                                                            '{"Id":' +
                                                                values.Id +
                                                                ',"IsActivate":"' +
                                                                values.IsActivate +
                                                                '","IsVerified":"' +
                                                                values.IsVerified +
                                                                '","FilterCountry":"' +
                                                                values.FilterCountry +
                                                                '", "Maximum":"' +
                                                                values.Maximum +
                                                                '", "Minimum":"' +
                                                                values.Minimum +
                                                                '", "Order":"' +
                                                                values.Order +
                                                                '", "FeaturedOrder":"' +
                                                                values.FeaturedOrder +
                                                                '", "Rows":"' +
                                                                values.Rows +
                                                                '", "Columns":"' +
                                                                values.Columns +
                                                                '", "Note":"' +
                                                                values.Note +
                                                                '", "Partner":"' +
                                                                values.Partner +
                                                                '", "New":"' +
                                                                values.New +
                                                                '"}', // JSON string for the request body
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message('Error! '); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    webix.message(
                                                                        'Producto Partner Editado', // Show success message
                                                                    );
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload the grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    this.getTopParentView().hide(); // Hide the popup
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    $$('editform').bind($$('datatable')); // Bind the edit form to the datatable
                    popupAdd = webix.ui({
                        // Create add popup
                        view: 'window',
                        id: 'AddPartnerProducts', // ID for the add window
                        width: screen.width < 500 ? 500 : 600, // Set width based on screen size
                        height: screen.width < 500 ? 470 : 520, // Set height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            // Header configuration
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Añadir Producto Partner'), // Localized label
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        // Close button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Modal popup
                        body: {
                            // Body configuration
                            view: 'scrollview', // Scrollable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            body: {
                                view: 'form', // Form view
                                id: 'addform', // ID for the add form
                                width: screen.width < 500 ? 500 : 600, // Set width based on screen size
                                height: screen.width < 500 ? 470 : 470, // Set height based on screen size
                                elements: [
                                    // Form elements
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for Product
                                                labelPosition: 'top',
                                                label: 'Productos', // Label for Product
                                                name: 'Product', // Name for the input
                                                options: {
                                                    // Options for the combo input
                                                    body: {
                                                        dataFeed: function (text) {
                                                            // Data feed function for dynamic options
                                                            var vthis = this; // Reference to the current instance
                                                            if (
                                                                text.length > 2 // Check if input length is greater than 2
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'es/Select/GamesCasinoSelect', // API URL for fetching games
                                                                        '{"Filter":"' + text + '"}', // JSON string for the request body
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var resp = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    !resp.HasError // Check for errors in response
                                                                                ) {
                                                                                    vthis.parse(
                                                                                        resp.Data, // Parse data into the combo
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    },
                                                },
                                            },
                                            {
                                                view: 'combo', // Combo input for Partner
                                                labelPosition: 'top',
                                                label: 'Partner', // Label for Partner
                                                name: 'Partner', // Name for the input
                                                options: profile.Partners, // Options from profile
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for IsActivate
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'IsActivate', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo input for IsVerified
                                                labelPosition: 'top',
                                                label: _('Verificado'), // Localized label
                                                name: 'IsVerified', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for FilterCountry
                                                labelPosition: 'top',
                                                label: _('Filtro País'), // Localized label
                                                name: 'FilterCountry', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Localized value
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Localized value
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'text', // Text input for Processing Time
                                                labelPosition: 'top',
                                                label: _(
                                                    'Tiempo Procesamiento', // Localized label
                                                ),
                                                name: 'ProcessingTime', // Name for the input
                                                labelWidth: 160, // Label width
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Maximum
                                                labelPosition: 'top',
                                                label: _('Máximo'), // Localized label
                                                name: 'Maximum', // Name for the input
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Minimum
                                                labelPosition: 'top',
                                                label: _('Mínimo'), // Localized label
                                                name: 'Minimum', // Name for the input
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo', // Combo input for New
                                                labelPosition: 'top',
                                                label: _('¿Es nuevo?'), // Localized label
                                                name: 'New', // Name for the input
                                                options: [
                                                    // Options for the combo input
                                                    { id: 'S', value: _('Si') }, // Localized value
                                                    { id: 'N', value: _('No') }, // Localized value
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text', // Text input for Order
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order', // Name for the input
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for FeaturedOrder
                                                labelPosition: 'top',
                                                label: _('Orden Destacado'), // Localized label
                                                name: 'FeaturedOrder', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Rows
                                                labelPosition: 'top',
                                                label: _('Filas'), // Localized label
                                                name: 'Rows', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input for Columns
                                                labelPosition: 'top',
                                                label: _('Columnas'), // Localized label
                                                name: 'Columns', // Name for the input
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Localized button text
                                                click: function () {
                                                    // Click event for cancel button
                                                    this.getTopParentView().hide(); // Hide the popup
                                                    $$('addform').clear(); // Clear the add form
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Localized button text
                                                click: function ($e) {
                                                    // Click event for save button
                                                    var values = $$('addform').getValues(); // Get form values
                                                    var c2this = this; // Reference to the current instance
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for the request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnerProduct/CreatePartnerProduct', // API URL for creating partner product
                                                            values, // Send form values as request body
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message('Error! '); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    text = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        text.HasError // Check for errors in response
                                                                    ) {
                                                                        webix.message(
                                                                            'Error: ' + text.AlertMessage, // Show error message
                                                                        );
                                                                    } else {
                                                                        $$('addform').clear(); // Clear the add form
                                                                        c2this.getTopParentView().hide(); // Hide the popup
                                                                        webix.message(
                                                                            'Producto Partner Agregado', // Show success message
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                },
            });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            // Event handler for adding product partner
            if (optionsCategorias.length > 0 && products.length > 0) {
                // Check if categories and products are loaded
                $$('addform').clearValidation(); // Clear validation on the add form
                popupAdd.show(); // Show add popup
                var optionsCountries = $$('AddProduct').getList(); // Get options for countries
                optionsCountries.clearAll(); // Clear existing options
                optionsCountries.parse(products); // Parse products into the options
            } else {
                webix.message({
                    // Show error message if data is not loaded
                    text: _('Datos no han podido ser cargados'), // Localized error message
                    title: _('¡Error!'), // Localized title
                    type: 'alert-error', // Alert type
                });
            }
        });
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            // Event handler for filtering partner products
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Loop through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Check if the key is Datepicker
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Loop through nested object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check if key is start
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check if key is end
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data into the grid
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with item Id
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by PlayerId
            );
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data into the grid
            );
        });
        // AJAX request to fetch products
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Report/GetProducts', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize Id field
                            .replace(/"Name"/g, '"value"'), // Normalize Name field
                    );
                    console.log(data); // Log fetched data
                    products = data.Data; // Store products data
                },
            });
    }
}

// FILE DOCUMENTED
